// extracted by mini-css-extract-plugin
export default {"quiz":"QuizList_quiz__htwDN","header":"QuizList_header__NaewQ","filters":"QuizList_filters__1fbxg","rotate":"QuizList_rotate__0wpMG"};